import { h, Component } from 'preact';
import { Subject } from 'rxjs';
import cx from 'classnames';

import hopplerLinkState from '../../../../utils/forms/hoppler-linkstate';
import { Listing } from '../../../../../types';
import { Role, User } from '../../../../../types';
import { Form } from '../../../../utils/forms/form';
import { ADMIN_GROUP } from '../../../../../constants/roles';

import * as roles from '../../../../core/roles';

interface ListingEditorOtherSectionProps {
  listing?: Listing;
  currentUser?: User;
  form?: Form;
  formSubject?: Subject<Form>;
  isPending?: number;
}

interface ListingEditorOtherSectionState {}

export class ListingEditorOtherSection extends Component<ListingEditorOtherSectionProps, ListingEditorOtherSectionState> {
  render() {

    const { 
      listing,
      currentUser, 
      isPending,
      form,
      formSubject } = this.props;

    const userIsSd = roles.userHasRole(currentUser, Role.SALES_DIRECTOR);
    const userIsAdmin = roles.isInGroup(currentUser, ADMIN_GROUP);
    const userHasListingsRole = roles.userHasAnyRole(currentUser, [ Role.LISTINGS ]);

    return (
      <div>
      {
        userIsSd || userIsAdmin || userHasListingsRole ? (
          <div className="mt-4 d-flex flex-column border-top">
            <div className="hi-input-group mt-3">
              <label className="hi-input-group__label">360&deg; Tour Link</label>
              <input 
                type="text"
                placeholder="360&deg; tour link"
                className={ cx('form-control hi-text-input', {
                  'invalid': !form.fields['tour360Url'].isValid
                })}
                disabled={ isPending == 1 || !listing.canEdit }
                value={ form.fields['tour360Url'].value }
                onInput={ hopplerLinkState(formSubject, form, 'tour360Url') } />
              { !form.fields['tour360Url'].isValid ?
                <small className="d-block mt-1 text-danger">
                  Please enter a valid URL.
                </small> : null 
              }
            </div>

            <div className="hi-input-group mt-3">
              <label className="hi-input-group__label">Video Link</label>
              <input 
                type="text"
                placeholder="Video link"
                className={ cx('form-control hi-text-input', {
                  'invalid': !form.fields['videoUrl'].isValid
                })}
                disabled={ isPending == 1 || !listing.canEdit }
                value={ form.fields['videoUrl'].value }
                onInput={ hopplerLinkState(formSubject, form, 'videoUrl') } />
              { !form.fields['videoUrl'].isValid ?
                <small className="d-block mt-1 text-danger">
                  Please enter a valid URL.
                </small> : null 
              }
            </div>
    
            <div className="hi-input-group mt-4">
              <label className="hi-input-group__label">Live Viewing Link</label>
              <input 
                type="text"
                placeholder="Live viewing link"
                className={ cx('form-control hi-text-input', {
                  'invalid': !form.fields['liveVideoUrl'].isValid
                })}
                disabled={ isPending == 1 || !listing.canEdit }
                value={ form.fields['liveVideoUrl'].value }
                onInput={ hopplerLinkState(formSubject, form, 'liveVideoUrl') } />
                { !form.fields['liveVideoUrl'].isValid ?
                  <small className="d-block mt-1 text-danger">
                    Please enter a valid URL.
                  </small> : null 
                }
            </div>
          </div>
        ) : null
      }
      </div>
    )
  }
}
